import { Div, Image, Text } from "view/lib/components";

interface Props {
  readonly data: Record<string, string>;
}

const Homepage = ({ data }: Props) =>
  <Div style={styles.container}>
    <Div style={styles.textContainer}>
      <Text style={styles.greeting}>Hello, Welcome</Text>
      <Text style={styles.name}>I am Ruturaj Gole</Text>
      <Text style={styles.subtext}>
        I am a Professional Web Developer, Mobile App Developer and a Machine Learning Enthusiast.
        I also have a keen interest in the natural sciences and languages. 
        If you wish to know more, please navigate the website to gain more information. 
      </Text>
    </Div>
    <Div style={styles.subPart}>
      <Image src={`${process.env.PUBLIC_URL}/main.png`} style={styles.image}/>
    </Div>
  </Div>;

const styles = {
  container: {
    maxWidth: "100%",
    justifyContent: ["center", "center", "space-around"],
    alignItems: "center",
    height: "100%",
    width: "100vw",
    backgroundColor: "#ACC8E5",
    display: "flex",
    flexDirection: ["column", "column", "row"],
    padding: "1%",
  },
  textContainer: {
    alignItems: "start",
    justifySelf: "start",
    display: "flex",
    flex: ["0", "0", "1"],
    margin: ["1%", "1%", "0% 5%"],
    flexDirection: "column"
  },
  greeting: {
    fontSize: ["x-large", "x-large", "xx-large"],
    lineHeight: [1, 1, 3],
    color: "black"
  },
  subPart: {
    display: "flex",
    flex: "1",
    margin: "0% 5%"
  },
  image: {
    width: "90%",
    objectFit: "cover",
    borderRadius: "10%",
    borderBottom: "5px double black",
    borderTop: "5px double black",
    borderRight: "3px double white",
    borderLeft: "3px double white",
    background: "transparent"
  },
  name: {
    fontSize: ["xx-large", "xx-large", "xxx-large"],
    lineHeight: [1, 1, 2]
  },
  subtext: {
    fontSize: "large"
  }
} as const;

export default Homepage;